import React, { useMemo } from 'react';

import { USER_ID_TYPES } from './consts';
import { DefaultDisplayUserError } from './DefaultDisplayUserError';
import { DefaultDisplayUserLoader } from './DefaultDisplayUserLoader';
import {
  FormattedDisplayUserOptions,
  useFormattedUser,
} from './hooks/useFormattedUser';

type DisplayUserNameProps = {
  id: string;
  idType?: USER_ID_TYPES[keyof USER_ID_TYPES];
  options?: FormattedDisplayUserOptions;
  renderLoader?: () => React.JSX.Element;
  renderError?: () => React.JSX.Element;
};

export const DisplayUserName = ({
  id,
  idType,
  options,
  renderLoader = () => <DefaultDisplayUserLoader />,
  renderError = () => <DefaultDisplayUserError />,
}: DisplayUserNameProps) => {
  const { formatDisplayUser, loading, error } = useFormattedUser({
    searchBy: idType,
  });

  const { displayName } = useMemo(
    () => formatDisplayUser(id, options),
    [formatDisplayUser, id, options],
  );

  if (!displayName && loading) {
    return renderLoader();
  }

  if (!displayName || error) {
    return renderError();
  }

  return <>{displayName}</>;
};
